import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import Checkbox from '../../components/Checkbox';
import { IErrorMessage } from '../../components/errorMessage/errorMessage.type';
import InputField from '../../components/InputField';
import { CheckboxWrapper } from './NewPassword';

interface IPasswordFieldProps {
    autoFocus?: boolean;
    id?: string;
    labelId?: string;
    intl: InjectedIntl;
    value?: string;
    required?: boolean;
    qaId?: string;
}

interface IPasswordFieldState {
    showPassword: boolean;
}

class CurrentPasswordField extends React.Component<IPasswordFieldProps, IPasswordFieldState> {
    private readonly ID: string;
    private readonly LABEL_ID: string;
    private readonly MAX_LENGTH: number;

    state = {
        showPassword: false,
    };

    constructor(props: IPasswordFieldProps) {
        super(props);

        const { id, labelId } = this.props;

        this.ID = id ? id : 'password';
        this.LABEL_ID = labelId ? labelId : 'label.password';
        this.MAX_LENGTH = 128;

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        this.onChangeShowPassword = this.onChangeShowPassword.bind(this);
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderInputField} />;
    }

    private validate(value: string): IErrorMessage {
        const { required } = this.props;

        if (!value && required) {
            return TranslationHelpers.getMessageDescriptor('error.password.missing');
        }

        return '';
    }

    private onChangeShowPassword(e: any) {
        this.setState({ showPassword: e.target.checked });
    }

    private renderInputField({ form: { touched, errors } }: FieldProps): ReactNode {
        const { autoFocus, value, required, qaId, intl } = this.props;

        const currPwdCheckBoxAriaLabel = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor('label.show_password'),
        );

        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        let isValid;
        if (value && errorMessage) {
            isValid = false;
        }
        if (value && !errorMessage) {
            isValid = true;
        }

        return (
            <InputField
                autoComplete="current-password"
                labelMessage={TranslationHelpers.getMessageDescriptor(this.LABEL_ID)}
                type={this.state.showPassword ? 'text' : 'password'}
                id={this.ID}
                name={this.ID}
                value={value}
                error={errorMessage}
                autoFocus={autoFocus}
                required={required}
                maxLength={this.MAX_LENGTH}
                convert={false}
                data-qa-id={`${qaId ? qaId : 'current-password'}-field`}
                valid={isValid}
            >
                <CheckboxWrapper>
                    <Checkbox
                        id="showCurrentPassword"
                        name="showCurrentPassword"
                        ariaLabel={currPwdCheckBoxAriaLabel}
                        label="label.show_password"
                        value={this.state.showPassword}
                        onChange={this.onChangeShowPassword}
                        tooltipText={false}
                    />
                </CheckboxWrapper>
            </InputField>
        );
    }
}

export default injectIntl(CurrentPasswordField);
